import React from 'react'
import './ContactUsQueriesComponent.css'

const ContactUsQueriesComponent = () => {
  return (
    <div className="banner_section" style={{ flex: 1 }}>
      ContactUsQueriesComponent
    </div>
  )
}

export default ContactUsQueriesComponent
